export interface Font {
  name: string;
  fontFamily: string;
}

export const fonts: Font[] = [
  {
    name: 'Arial',
    fontFamily: 'Arial, Helvetica, sans-serif',
  },
  {
    name: 'Arial Black',
    fontFamily: 'Arial Black, Gadget, sans-serif',
  },
  {
    name: 'Comic Sans MS',
    fontFamily: 'Comic Sans MS, Textile, cursive',
  },
  {
    name: 'Courier New',
    fontFamily: 'Courier New, Courier, monospace',
  },
  {
    name: 'Georgia',
    fontFamily: 'Georgia, Times New Roman, Times, serif',
  },
  {
    name: 'Impact',
    fontFamily: 'Impact, Charcoal, sans-serif',
  },
  {
    name: 'Lucida Console',
    fontFamily: 'Lucida Console, Monaco, monospace',
  },
  {
    name: 'Lucida Sans Unicode',
    fontFamily: 'Lucida Sans Unicode, Lucida Grande, sans-serif',
  },
  {
    name: 'Palatino Linotype',
    fontFamily: 'Palatino Linotype, Book Antiqua, Palatino, serif',
  },
  {
    name: 'Tahoma',
    fontFamily: 'Tahoma, Geneva, sans-serif',
  },
  {
    name: 'Times New Roman',
    fontFamily: 'Times New Roman, Times, serif',
  },
  {
    name: 'Trebuchet MS',
    fontFamily: 'Trebuchet MS, Helvetica, sans-serif',
  },
  {
    name: 'Verdana',
    fontFamily: 'Verdana, Geneva, sans-serif',
  },
  {
    name: 'MS Sans Serif',
    fontFamily: 'MS Sans Serif, Geneva, sans-serif',
  },
  {
    name: 'MS Serif',
    fontFamily: 'MS Serif, New York, serif',
  },
];
